import { render, staticRenderFns } from "./OrderInputs.vue?vue&type=template&id=107073d8&"
import script from "./OrderInputs.vue?vue&type=script&lang=js&"
export * from "./OrderInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports